export const PRICING = {
    ceilingUK: 900,
    ceilingEUR: 1000,
    floorUK: 250,
    floorEUR: 300,
};
